﻿import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PopupComponent } from './popup/popup.component';
import { HalfPopupComponent } from './popup/halfpopup.component';
import { TimePickerComponent } from './TimePicker/TimePicker.component';
import { CarousalComponent } from './carousal/carousal.component';
import { TimepickerModule, TimepickerConfig } from 'ngx-bootstrap';
import { ApptokenModule } from '../../app.token.module';
import { NewTimePickerComponent } from './TimePicker/NewTimePicker.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { SpeechRecognitionService } from './speech-recognition.service';
import { SpeechSearchDirective } from './speech-recognition.directive';
import { AppTranslationModule } from 'app/app.translation.module';
import { TooltipModule } from 'ngx-bootstrap';
import { ThumnaildragNdrop } from './drag-n-drop.directive';

@NgModule({
    imports: [FormsModule, CommonModule, TimepickerModule.forRoot(), ReactiveFormsModule, ApptokenModule.forRoot(), NgxMaterialTimepickerModule.forRoot(), AppTranslationModule, TooltipModule.forRoot()],
    exports: [PopupComponent, CarousalComponent, HalfPopupComponent, TimePickerComponent,
        FormsModule, CommonModule, ReactiveFormsModule, NewTimePickerComponent, SpeechSearchDirective, ThumnaildragNdrop],
    declarations: [PopupComponent, CarousalComponent, HalfPopupComponent, TimePickerComponent, NewTimePickerComponent, SpeechSearchDirective, ThumnaildragNdrop],
    providers: [TimepickerConfig, SpeechRecognitionService],
})
export class CoreModule { }
